import { createFileRoute } from '@tanstack/react-router';

import { EmailDocumentTemplateEditor } from 'src/sections/admin/email-document-templates/email-document-template-editor';

export const Route = createFileRoute('/admin-skidog/email-document-templates/$id')({
  component: EmailDocumentTemplateEditorPage,
});

function EmailDocumentTemplateEditorPage() {
  const { id } = Route.useParams();
  if (id === 'new') {
    return <EmailDocumentTemplateEditor />;
  }
  return <EmailDocumentTemplateEditor templateId={id} />;
}
